<template>
	<div class="page_shadow">
		<div class="page pdf-page">
			<h5 class="header">
				<span>目录</span>
			</h5>
			<div class="content" id="catalog_1">
				<div class="big_title_box">
					<div class="big_title"><span>Part1</span>基本信息</div>
					<div class="line"></div>
					<div class="page_number"></div>
				</div>
				<div class="big_title_box">
					<p class="big_title"><span>Part2</span>推荐升学途径</p>
					<div class="line"></div>
					<div class="page_number"></div>
				</div>
				<div class="big_title_box">
					<p class="big_title"><span>Part3</span>升学建议</p>
					<div class="line"></div>
					<div class="page_number"></div>
				</div>
				<div class="big_title_box">
					<p class="big_title"><span>Part4</span>学习状态自我诊断</p>
					<div class="line"></div>
					<div class="page_number"></div>
				</div>
                <div class="big_title_box">
					<p class="big_title"><span>Part5</span>学业提升建议</p>
					<div class="line"></div>
					<div class="page_number"></div>
				</div>
                <div class="big_title_box">
					<p class="big_title"><span>附1：</span>升学日历</p>
					<div class="line"></div>
					<div class="page_number"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	components: {  },
    props: [],
    data() {
        return {

        }
    },
    methods: {

    },
    watch: {

    },
    created() {
    	
    },
    mounted() {

    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
</style>